@if (isLoading) {
  <div class="inventory-item-tab__spinner">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'MESSAGES.LOADING' | translate }}</span>
    </div>
  </div>
}

@if (viewModel$ | async; as vm) {
  <div class="inventory-item-identification-tab" [formGroup]="overviewForm.form">
    @if (vm.previewFieldLabelKey) {
      <p class="inventory-item-identification-tab__notice">
        {{ 'COMPONENTS.INVENTORY_ITEM_OVERVIEW.PREVIEW_UPDATED' | translate: { field: (vm.previewFieldLabelKey | translate) } }}
      </p>
    }

    <div class="inventory-item-identification-tab__fields">
      @for (field of vm.fields; track field.controlName) {
        <app-dynamic-editable-field
          class="inventory-item-identification-tab__field"
          [formControlName]="field.controlName"
          layout="stacked"
          [editable]="field.editable !== false"
          [inputType]="field.inputType ?? 'text'"
          inputClass="input-sm"
          (updatedInput)="field.editableFieldName && onPreviewFieldUpdate(field.editableFieldName)"
        >
          <ng-template #labelTpl>
            <div class="inventory-item-identification-tab__field-label">
              {{ field.label | translate }}
            </div>
          </ng-template>
          <ng-template #contentTpl>
            <div class="inventory-item-identification-tab__field-value" [ngClass]="field.valueClass">
              @if (field.valueKey) {
                {{ field.valueKey | translate }}
              } @else if (field.controlName === 'lastSyncDate' || field.controlName === 'updatedAt') {
                {{ field.value ? (field.value | date: 'dd.MM.yyyy') : '' }}
              } @else {
                {{ field.value }}
              }
            </div>
          </ng-template>
        </app-dynamic-editable-field>
      }
    </div>
  </div>
}
